import styled from '@emotion/styled';

export const Title = styled.h2`
  text-transform: uppercase;
  text-align: center;
  color: #183e6c;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: white;
`;
export const SectionStat = styled.section`
  width: 250px;
  margin: 0 auto;
  padding: 50px 20px;
`;
export const StatList = styled.ul`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 0;
`;
export const Item = styled.li`
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 0;
  text-align: center;
  font-size: 16px;
  color: #f3f3f3;
  width: 50px;
`;
